import React, { useState, useEffect } from "react";
// import "../style.scss";
// import "./style.scss";
import Modal from "react-modal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getRouting,
  formDataGenerator,
  getLang,
} from "../../../../../utils/common";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getStateCityList, postSebiRegister } from "../actions";

const Recaptcha = require("react-recaptcha");

const registerModel = (props) => {
  const {
    getStateCityList,
    postSebiRegister,
    investorawarenessSatate,
    submitRegisterResponse,
    open,
    onClose,
  } = props;

  const [firstName, setfirstName] = useState();
  const [lastName, setlastName] = useState();
  const [email, setEmail] = useState();
  const [mobile, setMobile] = useState();
  const [telephone, setTelephone] = useState();
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [getselectStatedata, setgetselectStatedata] = useState();
  const [getselectCitylist, setgetselectCitylist] = useState();
  const [captchaToken, setCaptchaToken] = useState();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [emailSuccessMessage, setEmailSuccessMessage] = useState();
  // const [show, setShow] = useState(false);

  const handleSuccessClose = () => {
    setShowSuccessMessage(false);
    setShowSuccess(false);
    onClose();
    handleResetFormFields();
  };

  
  useEffect(() => {
    if (submitRegisterResponse && showSuccessMessage === true) {
      // setShow(false);
      setShowSuccess(true);
      onClose();

      if (submitRegisterResponse && submitRegisterResponse.status === true) {
        setEmailSuccessMessage("Email send successfully");
      } else if (
        submitRegisterResponse &&
        submitRegisterResponse.status === false
      ) {
        setEmailSuccessMessage("Registration Failed");
      }
      formik.resetForm();
      setgetselectStatedata("");
    }
  }, [submitRegisterResponse]);

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
  const firstlastRegExp = /^[A-Za-z]+$/;
  const telephonenumb = /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .matches(firstlastRegExp, "Please Enter your First Name")
      .required("Please Enter your First Name details"),
    lastName: Yup.string()
      .matches(firstlastRegExp, "Please Enter your Last Name")
      .required("Please Enter your Last Name details"),
    email: Yup.string()
      .email("email is not correct")
      .required("Please Enter your Email")
      .matches(/^\w+([-+.']\w+)*@[A-Za-z\d]+\.com$|.in$/,'Incorrect email'),
    mobile: Yup.string()
      .matches(phoneRegExp, "Mobile number is not valid")
      .required("Please enter mobile number")
      .min(10, "Mobile must be at least 10 characters")
      .max(10, "Mobile must not exceed 10 characters"),
    // telephone: Yup.string().required('Please enter mobile number'),
    // state: Yup.string().required('Please Select state'),
    city: Yup.string().required("Please Select city"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      telephone: "",
      state: "",
      city: "",
      captchaToken: "",
    },
    validationSchema,
    // validateOnChange: false,
    // validateOnBlur: false,
    onSubmit: (data) => {
      setShowSuccessMessage(true);

      let payload = {
        firstname: data.firstName,
        lastname: data.lastName,
        email: data.email,
        mobile: data.mobile,
        landline: data.telephone,
        state: getselectStatedata,
        city: data.city,
        captchaToken: captchaToken,
      };
      postSebiRegister(formDataGenerator(payload));
    },
  });
  
  useEffect(() => {
    getStateCityList(getLang());
  }, []);

  const handleChangeCity = (event) => {
    const arrayMap = investorawarenessSatate && investorawarenessSatate.content;
    arrayMap.length > 0 && arrayMap.map((item) => {
      if (item.state == event.target.value) {
        setgetselectStatedata(event.target.value);
        setgetselectCitylist(item.cities);
      }
    });
    setCity();
  };

  // specifying your onload callback function
  var callback = function () {
    console.log("Done!!!!");
  };

  const verifyCallback = (response) => {
    setCaptchaToken(response);
  };

  useEffect(() => {
    if (formik.values.firstName) {
      setfirstName(formik.values.firstName);
    }
  }, [formik.values.firstName]);
  useEffect(() => {
    if (formik.values.lastName) {
      setlastName(formik.values.lastName);
    }
  }, [formik.values.lastName]);

  useEffect(() => {
    if (formik.values.email) {
      setEmail(formik.values.email);
    }
  }, [formik.values.email]);

  useEffect(() => {
    if (formik.values.mobile) {
      setMobile(formik.values.mobile);
    }
  }, [formik.values.mobile]);

  useEffect(() => {
    if (formik.values.telephone) {
      setTelephone(formik.values.telephone);
    }
  }, [formik.values.telephone]);

  useEffect(() => {
    if (formik.values.state) {
      setState(formik.values.state);
    }
  }, [formik.values.state]);

  useEffect(() => {
    if (formik.values.city) {
      setCity(formik.values.city);
    }
  }, [formik.values.city]);

  let recaptchaInstance;

  const handleResetFormFields = () => {
    formik.resetForm();
    setgetselectStatedata("");
    setgetselectCitylist("");
    setCaptchaToken();
    recaptchaInstance.reset();
  }

  const handleOnCloseFields = () => {
    handleResetFormFields();
    onClose();
  }


  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={onClose}
        contentLabel="Example Modal"
        centered
        className="registermodal"
      >
        <div className="d-flex justify-content-between align-items-center w-100 modal-header">
          <div className="ms-4">
            <p className="text-start modaltxt">Registration</p>
            <p className="text-start">Investor Awareness Programmes</p>
          </div>

          <img
            src="/images/New/red-arrow-close.svg"
            width={25}
            height={25}
            alt="close"
            onClick={handleOnCloseFields}
            className="cursorp"
          />
        </div>
        <div>
          <div className="container">
            <form className="p-0 mt-5 mt-md-0" onSubmit={formik.handleSubmit}>
              <div className="row mt-3">
                <div className="col-md-6 mb-4">
                  <input
                    type="text"
                    size="lg"
                    placeholder="First Name*"
                    name="firstName"
                    onChange={formik.handleChange}
                    value={formik.values.firstName}
                    onKeyPress={(event) => {
                      if (!/^[A-Za-z]+$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(event)=>{
                      if (!/^[A-Za-z]+$/.test(event)) {
                        event.preventDefault();
                      }
                    }}
                    className={
                      "invalid form-control" +
                      (formik.errors.firstName && formik.touched.firstName
                        ? " is-invalid"
                        : "")
                    }
                    autoComplete='off'
                    aria-autocomplete="none"
                  />
                  <div className="invalid-feedback">
                    {formik.errors.firstName && formik.touched.firstName
                      ? formik.errors.firstName
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <input
                    type="text"
                    size="lg"
                    placeholder="Last Name*"
                    name="lastName"
                    onChange={formik.handleChange}
                    value={formik.values.lastName}
                    onKeyPress={(event) => {
                      if (!/^[A-Za-z]+$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(event)=>{
                      if (!/^[A-Za-z]+$/.test(event)) {
                        event.preventDefault();
                      }
                    }}
                    className={
                      "invalid form-control" +
                      (formik.errors.lastName && formik.touched.lastName
                        ? " is-invalid"
                        : "")
                    }
                    autoComplete='off'
                    aria-autocomplete="none"
                  />
                  <div className="invalid-feedback">
                    {formik.errors.lastName && formik.touched.lastName
                      ? formik.errors.lastName
                      : null}
                  </div>
                </div>
                <div className="col-md-12 mb-4">
                  <input
                    type="email"
                    size="lg"
                    placeholder="Email*"
                    name="email"
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    className={
                      "invalid form-control" +
                      (formik.errors.email && formik.touched.email
                        ? " is-invalid"
                        : "")
                    }
                    autoComplete='off'
                    aria-autocomplete="none"
                  />
                  <div className="invalid-feedback">
                    {formik.errors.email && formik.touched.email
                      ? formik.errors.email
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <input
                    type="number"
                    size="lg"
                    placeholder="Mobile Number*"
                    name="mobile"
                    onChange={formik.handleChange}
                    value={formik.values.mobile}
                    onKeyPress={(event) => {
                      if (!/^[0-9.\b]+$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(event)=>{
                      if (!/^[0-9.\b]+$/.test(event)) {
                        event.preventDefault();
                      }
                    }}
                    maxLength={10}
                    className={
                      "invalid form-control" +
                      (formik.errors.mobile && formik.touched.mobile
                        ? " is-invalid"
                        : "")
                    }
                    autoComplete='off'
                    aria-autocomplete="none"
                  />
                  <div className="invalid-feedback">
                    {formik.errors.mobile && formik.touched.mobile
                      ? formik.errors.mobile
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <input
                    type="number"
                    size="lg"
                    placeholder="Telephone"
                    name="telephone"
                    onChange={formik.handleChange}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    value={formik.values.telephone}
                    className={
                      "invalid form-control" +
                      (formik.errors.telephone && formik.touched.telephone
                        ? " is-invalid"
                        : "")
                    }
                    autoComplete='off'
                    aria-autocomplete="none"
                  />
                  <div className="invalid-feedback">
                    {formik.errors.telephone && formik.touched.telephone
                      ? formik.errors.telephone
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <select
                    aria-label="Default select example"
                    size="lg"
                    name="state"
                    onChange={(e) => {
                      formik.handleChange;
                      handleChangeCity(e);
                    }}
                    value={getselectStatedata}
                    className={
                      "fontStateCity invalid form-select" +
                      (formik.errors.state && formik.touched.state
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option>State*</option>
                    {investorawarenessSatate &&
                      investorawarenessSatate.content &&
                      investorawarenessSatate.content.length > 0 &&
                      investorawarenessSatate.content.map((state, index) => (
                        <option value={state.state}>{state.state}</option>
                      ))}
                  </select>
                  <div className="invalid-feedback">
                    {formik.errors.state && formik.touched.state
                      ? formik.errors.state
                      : null}
                  </div>
                </div>
                <div className="col-md-6 mb-4">
                  <select
                    aria-label="Default select example"
                    size="lg"
                    name="city"
                    onChange={formik.handleChange}
                    value={formik.values.city}
                    className={
                      "fontStateCity invalid form-select" +
                      (formik.errors.city && formik.touched.city
                        ? " is-invalid"
                        : "")
                    }
                  >
                    <option>City*</option>
                    {getselectCitylist &&
                      getselectCitylist.length > 0 &&
                      getselectCitylist.map((city, index) => (
                        <option value={city}>{city}</option>
                      ))}
                  </select>
                  <div className="invalid-feedback">
                    {formik.errors.city && formik.touched.city
                      ? formik.errors.city
                      : null}
                  </div>
                </div>
                <div className="col-md-12 mb-4">
                  <Recaptcha
                    ref={e => recaptchaInstance = e}
                    sitekey="6LcKVAsUAAAAAFIptnZfbQ35CNbQdYI4YOW40tuX"
                    render="explicit"
                    verifyCallback={verifyCallback}
                    onloadCallback={callback}
                  />
                </div>
                <div className="col-md-12 text-center mb-4">
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={
                      firstName == undefined ||
                      lastName == undefined ||
                      email == undefined ||
                      mobile == undefined ||
                      getselectStatedata == undefined ||
                      city == undefined ||
                      captchaToken == undefined
                    }
                  >
                    Submit
                  </button>
                  <p className="orcls my-2">or</p>
                  <a
                    href="#"
                    onClick={handleResetFormFields}
                    className="reset mb-3"
                  >
                    RESET
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      {/* Success Modal Start */}
      <Modal
        isOpen={showSuccess}
        onRequestClose={handleSuccessClose}
        contentLabel="Example Modal"
        className="successmodal"
      >
        <div>
          <div className="container">
            <div>
              <img
                src="/images/New/red-arrow-close.svg"
                width={25}
                height={25}
                alt="close"
                className="btn-close successclose "
                onClick={handleSuccessClose}
              />
              <p className="successtext">{emailSuccessMessage}</p>
            </div>
          </div>
        </div>
      </Modal>
      {/* Success Modal Start */}
    </>
  );
};

const mapStateToProps = (state) => ({
  investorawarenessSatate: state.LearnsCorners.investorawarenessSatate,
  submitRegisterResponse: state.LearnsCorners.submitRegisterResponseData,
});

const mapDispatchToProps = (dispatch) => ({
  getStateCityList: bindActionCreators(getStateCityList, dispatch),
  postSebiRegister: bindActionCreators(postSebiRegister, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(registerModel);
